import { EndpointPermissionRule } from 'src/app/core/permissions/endpoint-permission.models';
import { GOREV_PANOSU_ENDPOINT_EXTRA_RULES } from './gorev-panosu-endpoint-rules.extra';
import { ANALIZ_ENDPOINT_EXTRA_RULES } from './analiz-endpoint-rules.extra';
import { EMISYON_FAKTORLERI_ENDPOINT_EXTRA_RULES } from './emisyon-faktorleri-endpoint-rules.extra';
import { HESAPLAMA_ENDPOINT_EXTRA_RULES } from './hesaplama-endpoint-rules.extra';
import { MUHASEBE_ENDPOINT_EXTRA_RULES } from './muhasebe-endpoint-rules.extra';
import { RAPORLAR_ENDPOINT_EXTRA_RULES } from './raporlar-endpoint-rules.extra';
import { SU_AYAK_IZI_ENDPOINT_EXTRA_RULES } from './su-ayak-izi-endpoint-rules.extra';
import { TEDARIKCI_ENDPOINT_EXTRA_RULES } from './tedarikci-endpoint-rules.extra';
import { UYGULAMA_YONETIMI_ENDPOINT_EXTRA_RULES } from './uygulama-yonetimi-endpoint-rules.extra';
import { YONETIM_ENDPOINT_EXTRA_RULES } from './yonetim-endpoint-rules.extra';

/**
 * Generator'ın kaçırdığı veya çoklu permission gerektiren kurallar.
 * EXTRA kurallar RULES'tan önce eşleştirilir (aynı pattern'de EXTRA öncelikli).
 */
export const ENDPOINT_PERMISSION_EXTRA_RULES: readonly EndpointPermissionRule[] =
  [
    ...GOREV_PANOSU_ENDPOINT_EXTRA_RULES,
    ...YONETIM_ENDPOINT_EXTRA_RULES,
    ...HESAPLAMA_ENDPOINT_EXTRA_RULES,
    ...ANALIZ_ENDPOINT_EXTRA_RULES,
    ...MUHASEBE_ENDPOINT_EXTRA_RULES,
    ...RAPORLAR_ENDPOINT_EXTRA_RULES,
    ...TEDARIKCI_ENDPOINT_EXTRA_RULES,
    ...SU_AYAK_IZI_ENDPOINT_EXTRA_RULES,
    ...UYGULAMA_YONETIMI_ENDPOINT_EXTRA_RULES,
    ...EMISYON_FAKTORLERI_ENDPOINT_EXTRA_RULES,
    {
      method: 'POST',
      pattern: 'api/Emission/GetPrevYearData',
      permissionKeys: ['Hesaplama.GecmisYillar'],
      access: 'read',
    },
    {
      method: 'GET',
      pattern: 'api/Emission/GetPrevYearData',
      permissionKeys: ['Hesaplama.GecmisYillar'],
      access: 'read',
    },
    {
      method: 'GET',
      pattern: 'api/Emission/DownloadFileAttachment',
      permissionKeys: ['Hesaplama.GecmisYillar', 'Hesaplama.VeriGirisi'],
      access: 'read',
    },
    {
      method: 'POST',
      pattern: 'api/Emission/DownloadDocuments',
      permissionKeys: ['Hesaplama.GecmisYillar', 'Hesaplama.VeriGirisi'],
      access: 'read',
    },
    {
      method: 'GET',
      pattern: 'api/Emission/DownloadDocument',
      permissionKeys: ['Hesaplama.GecmisYillar', 'Hesaplama.VeriGirisi'],
      access: 'read',
    },
    {
      method: 'POST',
      pattern: 'api/Emission/UploadHotelAccommodationExcel',
      permissionKey: 'Hesaplama.TopluVeri',
      permissionKeys: ['Hesaplama.TopluVeri', 'Hesaplama.VeriYukleme'],
      access: 'write',
    },
    {
      method: 'GET',
      pattern: 'api/Emission/GetSpendingExcelColumns',
      permissionKeys: ['Hesaplama.VeriGirisi'],
      access: 'read',
    },
    {
      method: 'GET',
      pattern: 'api/Emission/GetCalculationMethods',
      permissionKeys: ['Hesaplama.GecmisYillar', 'Hesaplama.VeriGirisi'],
      access: 'read',
    },
    {
      method: 'GET',
      pattern: 'api/Emission/GetEmissionCategories',
      permissionKeys: ['Hesaplama.GecmisYillar', 'Hesaplama.VeriGirisi'],
      access: 'read',
    },
    {
      method: 'GET',
      pattern: 'api/Emission/GetMeasurementUnits',
      permissionKeys: ['Hesaplama.GecmisYillar', 'Hesaplama.VeriGirisi'],
      access: 'read',
    },
  ];
